import { render, staticRenderFns } from "./NavBarMain.vue?vue&type=template&id=4c5138f5&"
import script from "./NavBarMain.vue?vue&type=script&lang=js&"
export * from "./NavBarMain.vue?vue&type=script&lang=js&"
import style0 from "./NavBarMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports